import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/internal-error.png'


const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-content md:pb-[75px] text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("img", {
        src: _imports_0,
        class: "inline-block",
        alt: "internal-error-image"
      }, null, -1)),
      _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "text-[19px] md:text-[21px] mt-[25px] md:mt-[33px] mb-[11px]" }, " Looks like we have an internal error, please try again later. ", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("p", null, " But no worries! Our team is looking ever where while you wait safely. ", -1)),
      _createVNode(_component_RouterLink, {
        to: "/dashboard",
        class: "inline-block font-medium rounded-md md:text-md mt-[2px] md:mt-[12px] py-[12px] px-[25px] text-white bg-primary-500 transition-all hover:bg-primary-400"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(" Back to Dashboard ")
        ])),
        _: 1,
        __: [0]
      })
    ])
  ]))
}